angular.module('tgaAdmin').directive('apexChart', () => ({
  template: '<div></div>',
  scope: {
    options: '=',
  },
  link(scope, elem) {
    // init ApexCharts and call render
    let chart = new ApexCharts(elem[0], angular.copy(scope.options));
    chart.render();

    scope.$watch('options', (newOptions, oldOptions) => {
      if (_.isObject(newOptions) && newOptions !== oldOptions) {
        // Couldn't get these to work, too buggy
        // chart.resetSeries();
        // chart.updateOptions(newOptions);
        chart.destroy();
        chart = new ApexCharts(elem[0], newOptions);
        chart.render();
      }
    }, true);

    scope.$on('$destroy', () => {
      if (_.isObject(chart)) {
        chart.destroy();
      }
    });
  },
}));
